import { useSelector } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as pathUtils from "../../../abstract/controller/utils/pathUtils";
import { isNonNullish } from "../../../abstract/controller/utils/systemUtils";
import useNodeTraversal from "../../../abstract/hook/useNodeTraversal";
import styles from "./ChildrenParameter.module.scss";
import ReadOnlyParameterPanel from "./ReadOnlyParameterPanel";
import ParameterStructure from "./structure/ParameterStructure";
import { getIsFolded } from "../../../abstract/redux/slice/metaSlice";

function ChildrenParameter({ node, idContainer, readOnly = false }) {
  const _id = nodeUtils.getID(node);
  const _uuid = nodeUtils.getUUID(node);
  const _nodeTarget = useNodeTraversal(_id);

  const _isFolded = useSelector(getIsFolded(_uuid));
  
  if (!pathUtils.getName(_id)) {
    return null;
  }

  const _hasParameters = nodeUtils.hasParameters(_nodeTarget);

  if (_isFolded || !_hasParameters) {
    return null;
  }

  const _idTarget = nodeUtils.getIdTarget(node);
  const _defaultValue = nodeUtils.getValueDefault(node);

  const _parsedReadOnly = readOnly || _idTarget || isNonNullish(_defaultValue);

  const _parameters = nodeUtils.getParameters(_nodeTarget);

  const _rows = [];

  for (let i = 0; i < _parameters.length; i++) {
    _rows.push(
      <div key={nodeUtils.getUUID(_parameters[i])}>
        <ParameterStructure
          node={{
            current: _parameters[i],
            previous: i > 0 ? _parameters[i - 1] : null,
            next: i < _parameters.length - 1 ? _parameters[i + 1] : null,
            top: _nodeTarget
          }}
          position={{
            index: i,
            isFirst: i === 0,
            isOneBeforeLast: i === _parameters.length - 2,
            isLast: i === _parameters.length - 1,
            isNested: true
          }}
          idContainer={idContainer}
          readOnly={_parsedReadOnly}
        />
      </div>
    );
  }

  if (_parsedReadOnly) {
    _rows.push(<ReadOnlyParameterPanel key='closing panel'/>)
  }

  return (
    <div className={styles["children"]}>
      {_rows}
    </div>
  );
}

export default ChildrenParameter;
